import { render, staticRenderFns } from "./AppGoogleMapsWeatherLegend.vue?vue&type=template&id=54588b4c&scoped=true&"
import script from "./AppGoogleMapsWeatherLegend.vue?vue&type=script&lang=js&"
export * from "./AppGoogleMapsWeatherLegend.vue?vue&type=script&lang=js&"
import style0 from "./AppGoogleMapsWeatherLegend.vue?vue&type=style&index=0&id=54588b4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54588b4c",
  null
  
)

export default component.exports